 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		5: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		5: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"5f583372b15253b94ee97282aa62bfc97f7a5572","1":"dbf3ce33","2":"styles","3":"framework","4":"2d73464ec078822a67aad1fa0b165d2c2bdb6464","7":"component---src-pages-404-js","8":"component---src-pages-blogs-js","9":"component---src-pages-contact-us-js","10":"component---src-pages-events-conference-js","11":"component---src-pages-events-index-js","12":"component---src-pages-events-past-js","13":"component---src-pages-events-webinar-js","14":"component---src-pages-index-js","15":"component---src-pages-preview-js","16":"component---src-pages-product-pricing-js","17":"component---src-pages-request-a-demo-js","18":"component---src-templates-ad-landing-page-template-js","19":"component---src-templates-blog-blog-template-insight-js","20":"component---src-templates-blog-blog-template-tech-js","21":"component---src-templates-blog-category-insight-js","22":"component---src-templates-blog-category-tech-js","23":"component---src-templates-blog-index-insight-js","24":"component---src-templates-blog-index-tech-js","25":"component---src-templates-case-studies-case-study-template-js","26":"component---src-templates-case-studies-category-js","27":"component---src-templates-case-studies-index-js","28":"component---src-templates-page-template-js","29":"component---src-templates-policy-page-template-js","30":"component---src-templates-resources-category-js","31":"component---src-templates-resources-index-js","32":"component---src-templates-resources-resource-template-js","33":"component---src-templates-thank-you-page-template-js","35":"reactPlayerDailyMotion","36":"reactPlayerFacebook","37":"reactPlayerFilePlayer","38":"reactPlayerKaltura","39":"reactPlayerMixcloud","40":"reactPlayerMux","41":"reactPlayerPreview","42":"reactPlayerSoundCloud","43":"reactPlayerStreamable","44":"reactPlayerTwitch","45":"reactPlayerVidyard","46":"reactPlayerVimeo","47":"reactPlayerWistia","48":"reactPlayerYouTube"}[chunkId]||chunkId) + "-" + {"0":"e145755d1bdce0e9baae","1":"0d1e3f0a52bc96855d91","2":"f3e9059f8c2a75df70f2","3":"1bfc07ff87b6e757d13b","4":"aecd9e9540e4b00b0dd2","7":"053370e8c23a6a1cfba3","8":"3c5e3f79ac9ad2c7ea1a","9":"9f8bf5ac9570174f21dc","10":"464136009310d05bae83","11":"80b763faf52132b1b6d9","12":"9abaa099ed46d8a70356","13":"aa06f23f317b027515e4","14":"cd222a1127c1637d6e69","15":"c3b38203631acb16092c","16":"4214786e8a95f7393ea1","17":"ceda0ff66006d6eaf5c0","18":"79ac7ac15aaf32538989","19":"508803e45062d450e044","20":"cd0899a36e28736cb44f","21":"04422aa5fb6f8dff0ba0","22":"a101a725c1e45303b797","23":"d54f71f172046e418834","24":"101e6645e58403976f0a","25":"b6009e9fd732ee0e72dc","26":"610ddd6a1235d1f4385a","27":"56d708237e5f69b7bee9","28":"c14f9ea6e782c11efda5","29":"6a295e7eaadccb0f8403","30":"bd148554ad7cdc6d4747","31":"83da53ec2836c9a59140","32":"1ca4366ae3d8c618b198","33":"b20e956e34cb6b9bd207","35":"b9df65577a0b4687d40e","36":"3590a9ce805322b7b29a","37":"4b1edc1b91705274f6b5","38":"4763a2cf9cc5831efab7","39":"b813601bbf52505d38c1","40":"38c967236e237c469eed","41":"e7c0cbc822a959d2742a","42":"58d3f19bbbd63ccb430f","43":"9df74202fcf8d2377c75","44":"094273ebefbccabab87e","45":"d0a38a3753a4056f4cec","46":"7e6d4cc78c834bbc36ce","47":"3cdb8b65e629335d1365","48":"7e811f649a21040bbd7c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"5f583372b15253b94ee97282aa62bfc97f7a5572","1":"dbf3ce33","2":"styles","3":"framework","4":"2d73464ec078822a67aad1fa0b165d2c2bdb6464","7":"component---src-pages-404-js","8":"component---src-pages-blogs-js","9":"component---src-pages-contact-us-js","10":"component---src-pages-events-conference-js","11":"component---src-pages-events-index-js","12":"component---src-pages-events-past-js","13":"component---src-pages-events-webinar-js","14":"component---src-pages-index-js","15":"component---src-pages-preview-js","16":"component---src-pages-product-pricing-js","17":"component---src-pages-request-a-demo-js","18":"component---src-templates-ad-landing-page-template-js","19":"component---src-templates-blog-blog-template-insight-js","20":"component---src-templates-blog-blog-template-tech-js","21":"component---src-templates-blog-category-insight-js","22":"component---src-templates-blog-category-tech-js","23":"component---src-templates-blog-index-insight-js","24":"component---src-templates-blog-index-tech-js","25":"component---src-templates-case-studies-case-study-template-js","26":"component---src-templates-case-studies-category-js","27":"component---src-templates-case-studies-index-js","28":"component---src-templates-page-template-js","29":"component---src-templates-policy-page-template-js","30":"component---src-templates-resources-category-js","31":"component---src-templates-resources-index-js","32":"component---src-templates-resources-resource-template-js","33":"component---src-templates-thank-you-page-template-js","35":"reactPlayerDailyMotion","36":"reactPlayerFacebook","37":"reactPlayerFilePlayer","38":"reactPlayerKaltura","39":"reactPlayerMixcloud","40":"reactPlayerMux","41":"reactPlayerPreview","42":"reactPlayerSoundCloud","43":"reactPlayerStreamable","44":"reactPlayerTwitch","45":"reactPlayerVidyard","46":"reactPlayerVimeo","47":"reactPlayerWistia","48":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"8eb3c1f94085b423a591","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
